import { useTranslation } from "react-i18next";

const Data = () => {
  const { t } = useTranslation();

  return [
    // ==================== EDUCATION ====================
    {
      id: 1,
      category: "education",
      icon: "icon-graduation",
      year: `2023 – ${t('present') || 'heden'}`,
      title: "Bachelor ICT – Infrastructure & Cyber Security",
      desc: "Fontys Hogeschool, Eindhoven. Semesters 1 t/m 7: Cloud Migratie (Azure), DevOps & Orchestratie (vCenter/PowerShell), Pentesting & USB Security (NIST, RPi Pico), Geautomatiseerde Deployments (Ansible/Proxmox), Advanced Cyber Security (C4/STRIDE), Enterprise Architecture (TOGAF, Wazuh SIEM) en Kubernetes."
    },
    {
      id: 2,
      category: "education",
      icon: "icon-graduation",
      year: "2020 – 2023",
      title: "IT Expert Systems and Devices (Niveau 4)",
      desc: "Summa College, Eindhoven. Beheer van netwerk- en serverinfrastructuur, routing & switching, hardware diagnostics, virtualisatie en professionele stages."
    },

    // ==================== EXPERIENCE & INTERNSHIPS (CHRONOLOGISCH) ====================
    {
      id: 7,
      category: "experience",
      icon: "icon-briefcase",
      year: `Jul 2025 – ${t('present') || 'heden'}`,
      title: t("exp1_title") ? `${t("exp1_title")} – ${t("exp1_company")}` : "Sales Medewerker – IKEA",
      desc: t("exp1_desc") || "Klantadvisering, verkoop en servicegericht samenwerken."
    },
    {
      id: 8,
      category: "experience",
      icon: "icon-briefcase",
      year: "Sep 2025 – Jan 2026",
      title: t("exp2_title") ? `${t("exp2_title")} – ${t("exp2_company")} B.V.` : "Stagiair Automatisering – Van Boxtel B.V.",
      desc: "Onderzoeksstage: Ontwerpen en bouwen van een centrale proof-of-concept deployment-architectuur met Ansible en de Proxmox API om Red Hat Enterprise Linux (RHEL) servers geautomatiseerd, modulair en consistent uit te rollen."
    },
    {
      id: 3,
      category: "experience",
      icon: "icon-briefcase",
      year: "2022 – 2023",
      title: t("exp3_title") ? `${t("exp3_title")} – ${t("exp3_company")}` : "IT Stagiair – i-LEVEL ICT Solutions",
      desc: t("exp3_desc") || "Implementatie, beheer en onderhoud van netwerkinfrastructuur bij MKB-klanten. Uitvoeren van netwerktroubleshooting, switches/firewalls configureren, migraties en werkplek-/serverondersteuning."
    },
    {
      id: 4,
      category: "experience",
      icon: "icon-briefcase",
      year: "2021 – 2022",
      title: t("exp4_title") ? `${t("exp4_title")} – ${t("exp4_company")}` : "ZIT Stagiair (Zorg ICT) – Máxima Medisch Centrum (MMC)",
      desc: t("exp4_desc") || "Beheer en ondersteuning van de IT- en netwerkinfrastructuur binnen een ziekenhuisomgeving. Betrokken bij dagelijkse beheerprocessen, hoge beschikbaarheid en operationele beveiligingsprojecten in de zorgsector."
    }
  ];
};

export default Data;
